// JavaScript code for acf_blocks/hero-banner-cards component
(($) => {

    "use strict";
    if (!$('.acf-blocks-hero-banner-cards').length) {
        return;
    }
    console.log("acf_blocks/hero-banner-cards scripts loaded...");

    /**
    * Loops through each instance of the logos-carousel block and initializes the carousel for the logos container.
    * The carousel is set to autoplay, loop, and has specific responsive settings for different screen sizes.
    */
    $('.acf-blocks-hero-banner-cards .logos-carousel-block').each(function () {
        const $imagesContainerCarousel = $(this);
        $imagesContainerCarousel.owlCarousel({
            loop: true,
            autoplay: true,
            autoplayTimeout: 3000,
            margin: 40,
            nav: false,
            dots: false,
            responsiveBaseElement: 'body',
            responsive: {
                0: { items: 2 },
                576: { items: 3 },
                680: { items: 4 },
                768: { items: 5 },
                992: { items: 6 },
                1200: { items: 7 },
                1400: { items: 8 },
            }
        });
    });

})(jQuery);